/* ============================================================
   arthene — Bewegung der Startseite unterhalb des Heros

   Portiert aus prototypes/arthene-index-video-3.html (Block
   „Galerie-Motion"). Das Hero-Intro steckt weiterhin in
   arthene-hero-video.js — hier geht es nur um das, was beim
   Scrollen passiert:

     1. Reveals    Text staffelt sich herein, Bilder werden
                   von unten nach oben aufgezogen
     2. Parallaxe  die Werk-Tafeln driften leicht gegen den Scroll
     3. Streiflicht + leichte 3D-Neigung über den Werkkarten
     4. Magnetische Knöpfe (nur Zeigegeräte)

   Alle Klassen setzt ausschließlich dieses Skript. Ohne JavaScript
   und bei „Bewegung reduzieren" bleibt die Seite vollständig
   sichtbar und ruhig — das ist der Grund, warum im CSS kein
   Ausgangszustand ohne .rv-Klasse existiert.

   Die Styles dazu stehen am Ende von arthene-home.css.
   ============================================================ */
(function () {
  'use strict';

  var RUHIG = '(prefers-reduced-motion: reduce)';
  var ZEIGER = '(hover: hover)';

  /* Staffelung der Reveals: je Sektion 90 ms Versatz, gedeckelt —
     sonst wartet man in einer langen Werkreihe auf die letzte Karte. */
  var VERZUG_SCHRITT = 90;
  var VERZUG_MAX = 540;

  /* Laufzeit der Übergänge aus arthene-home.css (+ Puffer). Danach
     werden .rv/.rv-clip wieder entfernt: die Endlage ist ohnehin der
     Normalzustand, und ohne die lange .rv-Transition reagieren Hover,
     Neigung und Magnet wieder unmittelbar. */
  var RV_DAUER = 1100;
  var CLIP_DAUER = 1800;

  /* Magnet: der Prototyp hatte kleine Pillen-Knöpfe, im Theme sind es
     420 px breite „Wandschilder" und volle Katalogzeilen. Deshalb wird
     der Versatz gekappt statt rein proportional gerechnet — sonst
     rutschte ein breiter Knopf zwei Zentimeter zur Seite. */
  var MAGNET_X = 8;
  var MAGNET_Y = 5;

  var clipZu = new WeakMap();   /* beobachteter Container → Bild-Container */
  var beobachter = null;
  var driften = [];             /* Tafeln der Parallaxe */
  var scrollBereit = false;
  var geplant = false;

  function klemme(wert, max) {
    return wert > max ? max : wert < -max ? -max : wert;
  }

  /* ========================================================
     1. Reveals
     ======================================================== */

  function aufdecken(el, klasse, dauer) {
    el.classList.add('in');
    var verzug = parseFloat(el.style.getPropertyValue('--rd')) || 0;
    window.setTimeout(function () {
      el.classList.remove(klasse);
      el.classList.remove('in');
      el.style.removeProperty('--rd');
    }, verzug + dauer);
  }

  function beobachterHolen() {
    if (beobachter) return beobachter;
    beobachter = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          /* Clip-Reveals werden über ihren ELTERN beobachtet: Chrome
             rechnet die eigene clip-path-Fläche in die Sichtbarkeit ein —
             ein auf inset(0 0 100%) zugeklapptes Bild schneidet den
             Viewport nie und würde deshalb nie aufgedeckt. */
          var clip = clipZu.get(e.target);
          if (clip) aufdecken(clip, 'rv-clip', CLIP_DAUER);
          if (e.target.classList.contains('rv')) aufdecken(e.target, 'rv', RV_DAUER);
          beobachter.unobserve(e.target);
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );
    return beobachter;
  }

  var REVEAL_ZIEL =
    '.display, .lead, .body, .btn-outline, .feature__by, .feature__spec,' +
    ' .link-arrow, .work__link';
  var CLIP_ZIEL = '.verkauf__media, .feature__media';

  function initReveals() {
    var io = beobachterHolen();
    document.querySelectorAll('.page .sec, .foot').forEach(function (sec) {
      if (sec.dataset.artheneMotionReady === '1') return;
      sec.dataset.artheneMotionReady = '1';

      var i = 0;
      sec.querySelectorAll(REVEAL_ZIEL).forEach(function (el) {
        el.classList.add('rv');
        el.style.setProperty('--rd', Math.min(i++ * VERZUG_SCHRITT, VERZUG_MAX) + 'ms');
        io.observe(el);
      });

      sec.querySelectorAll(CLIP_ZIEL).forEach(function (el) {
        var eltern = el.parentElement;
        if (!eltern) return;
        el.classList.add('rv-clip');
        clipZu.set(eltern, el);
        io.observe(eltern);
      });
    });
  }

  /* ========================================================
     2. Parallaxe — nur transform, kein Layout
     ======================================================== */

  function rechnen() {
    geplant = false;
    var vh = window.innerHeight;
    driften.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh; /* −0,5 … 0,5 */
      el.style.transform = 'translateY(' + (-p * 34).toFixed(1) + 'px)';
    });
  }

  function anstossen() {
    if (geplant) return;
    geplant = true;
    window.requestAnimationFrame(rechnen);
  }

  function initParallaxe() {
    driften = Array.prototype.slice.call(document.querySelectorAll('.feature__media'));
    if (!driften.length) return;
    if (!scrollBereit) {
      scrollBereit = true;
      window.addEventListener('scroll', anstossen, { passive: true });
      window.addEventListener('resize', anstossen, { passive: true });
    }
    rechnen();
  }

  /* ========================================================
     3. Streiflicht + 3D-Neigung über den Werkkarten
     ======================================================== */

  function initNeigung() {
    document.querySelectorAll('.work__frame').forEach(function (f) {
      if (f.dataset.artheneNeigungReady === '1') return;
      f.dataset.artheneNeigungReady = '1';

      f.addEventListener('pointermove', function (e) {
        /* Solange die Karte noch hereinkommt, gehört sie dem Reveal. */
        if (f.closest('.rv')) return;
        var r = f.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        f.style.setProperty('--mx', x * 100 + '%');
        f.style.setProperty('--my', y * 100 + '%');
        f.style.transform =
          'rotateX(' + ((0.5 - y) * 6).toFixed(2) + 'deg)' +
          ' rotateY(' + ((x - 0.5) * 8).toFixed(2) + 'deg)';
      });
      f.addEventListener('pointerleave', function () {
        f.style.transform = '';
      });
    });
  }

  /* ========================================================
     4. Magnetische Knöpfe
     ======================================================== */

  function initMagnet() {
    document.querySelectorAll('.btn-outline, .link-arrow').forEach(function (b) {
      if (b.dataset.artheneMagnetReady === '1') return;
      b.dataset.artheneMagnetReady = '1';

      b.addEventListener('pointermove', function (e) {
        if (b.classList.contains('rv')) return;
        var r = b.getBoundingClientRect();
        var dx = klemme((e.clientX - r.left - r.width / 2) * 0.12, MAGNET_X);
        var dy = klemme((e.clientY - r.top - r.height / 2) * 0.22, MAGNET_Y);
        b.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () {
        b.style.transform = '';
      });
    });
  }

  /* ======================================================== */

  function initMotion() {
    if (window.matchMedia(RUHIG).matches) return;
    if (typeof IntersectionObserver !== 'function') return;

    initReveals();
    initParallaxe();

    if (!window.matchMedia(ZEIGER).matches) return; /* der Rest ist Zeiger-Sache */
    initNeigung();
    initMagnet();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion);
  } else {
    initMotion();
  }
  /* Theme-Editor: Sections werden ohne Seitenreload ausgetauscht. */
  document.addEventListener('shopify:section:load', initMotion);
})();
